// extracted by mini-css-extract-plugin
module.exports = {"app":"Common_app__iWEJK","appLight":"Common_appLight__2Nod5 Common_app__iWEJK","appDark":"Common_appDark__93--3 Common_app__iWEJK","widthContainer":"Common_widthContainer__152RV"};